import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=055cb3ff&"
import script from "./GlobalLoading.vue?vue&type=script&lang=ts&"
export * from "./GlobalLoading.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&id=055cb3ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports